var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/does-not-exceed-safe-integer.js
// module id = 2202
// module chunks = 0